import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
 

@Injectable({
  providedIn: 'root'
})
export class PdfDownloadService {

  constructor() { }

  downloadPDF(chartId: string, title: string, year: string, fromDate: string, toDate: string): void {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) return;

    // Increase the scale factor for better quality (e.g., 2 for HD)
    const scaleFactor = 3;

    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();

      // Get the current date and year
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title at the top
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add the current date and year below the title
      pdf.setFontSize(12);
      if(year && chartElement.id != 'bar-line-chart-nine-box' && chartElement.id != 'table-employee-wise-trends-data'){
        pdf.text(`Year: ${year}`, 10, 17); // Year on the left
      }else{
        if(year){
          pdf.text(`Employee: ${year}`, 10, 17); // Year on the left
        }
        
      }
      if (fromDate || toDate) {
        let dateText = '';
        if (fromDate) dateText += `From: ${fromDate}`;
        if (toDate) dateText += `${fromDate ? ' | ' : ''}To: ${toDate}`;
        pdf.text(dateText, 120, 17); // Display date range on the right
      }

 

      // Add chart image below the text
      const imgWidth = 190; // Adjust width
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
      pdf.addImage(imgData, 'PNG', 10, 25, imgWidth, imgHeight);

      // Save the PDF
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }
 
   
  downloadPDFMonthwise(chartId: string, title: string, year: string, month: string,): void {
    const chartElement = document.getElementById(chartId);
    if (!chartElement) return;

    // Increase the scale factor for better quality (e.g., 2 for HD)
    const scaleFactor = 3;

    html2canvas(chartElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();

      // Get the current date and year
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title at the top
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add the current date and year below the title
      pdf.setFontSize(12);
      pdf.text(`Year: ${year}`, 10, 17); // Year on the left

      if (month ) {
        let dateText = '';
        if (month) dateText += `Month: ${month}`;
        // if (toDate) dateText += `${fromDate ? ' | ' : ''}To: ${toDate}`;
        pdf.text(dateText, 150, 17); // Display date range on the right
      }

 

      // Add chart image below the text
      const imgWidth = 190; // Adjust width
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
      pdf.addImage(imgData, 'PNG', 10, 25, imgWidth, imgHeight);

      // Save the PDF
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }
   

}
